var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F3BA2F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_739_1471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.67081 9.04226L10.0014 6.71258L12.333 9.04415L13.6883 7.68786L10.0014 4L6.31451 7.68691L7.67081 9.04226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10.0006L5.35534 8.64429L6.71163 10.0006L5.35534 11.3559L4 10.0006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6708 10.9577L10.0014 13.2884L12.333 10.9568L13.6893 12.3112L10.0024 15.999L6.31451 12.314L7.6708 10.9577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2885 10.0006L14.6438 8.64429L16.0001 9.99963L14.6438 11.3569L13.2885 10.0006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3768 9.99949L10.0016 8.62329L8.98461 9.64027L8.86708 9.75685L8.62634 9.99759L10.0016 11.3719L11.3768 10.0004V9.99949Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_739_1471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.64a57f60d4176e57223597410b3c3dd4.svg";
export { ForwardRef as ReactComponent };